import { Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import WarningIcon from '@material-ui/icons/Warning'

import { getTranslate } from '../../localization'
import { AllocationStatus } from '../../types/inventoryAllocate'
import useStyles from './styles/StatusBox.styles'

interface BookingListAddFilterButtonProps {
  status: AllocationStatus
}

const StatusBox: React.FC<BookingListAddFilterButtonProps> = ({ status }) => {
  const classes = useStyles()
  const getColorForStatus = (s: AllocationStatus) => {
    switch (s) {
      case 'Failed':
        return 'red'
      case 'Retrying':
        return 'lightYellow'
      case 'InProgress':
        return 'blue'
      case 'Successfull':
        return 'green'
      default:
        break
    }
  }

  const isLong = status.length > 10

  return (
    <div>
      {getColorForStatus(status) === 'red' ? (
        <Typography
          variant="body1"
          className={[
            classes.text,
            classes.red,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{getTranslate(status)}</span>
          <ErrorIcon />
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightYellow' ? (
        <Typography
          variant="body1"
          className={[
            classes.text,
            classes.lightYellow,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{getTranslate(status)}</span>
          <WarningIcon />
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'green' ? (
        <Typography
          variant="body1"
          className={[
            classes.text,
            classes.green,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{getTranslate(status)}</span>
          <CheckCircleIcon />
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'blue' ? (
        <Typography
          variant="body1"
          className={[
            classes.text,
            classes.blue,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{getTranslate(status)}</span>
          <InfoIcon />
        </Typography>
      ) : null}
    </div>
  )
}

export default StatusBox
